import { useState, useEffect, useMemo } from 'react';
import { queryParamsFunction } from './queryParams';

function useGetInfo({ axiosInstance , api, queryParams = {}, toggleFetch }) {

    const [info, setInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')

    const url = useMemo(() => {
        const baseURL =  axiosInstance.defaults.baseURL
        return queryParamsFunction(baseURL, api, queryParams);

    }, [ api, queryParams, toggleFetch ])

    useEffect(() => {
        async function getInfo() {
            setIsLoading(true)
            try {

                const { data } = await axiosInstance.get(url);
                setInfo(data);
                setIsLoading(false)

            } catch (error) {
                setError(error)
                setIsLoading(false)
            }
        }


            getInfo();


    }, [url, api, toggleFetch])

    return { info, isLoading, error};
}

export { useGetInfo };
